export const DeliveryListHeadOfficePage = () => {
    return <>DeliveryListHeadOfficePage</>
}
